document.addEventListener('DOMContentLoaded',()=>{
    const lastChanceCollection = document.querySelector('.last-chance-collection');
    if(lastChanceCollection) {
        const lastChanceCollectionTooltip = lastChanceCollection.querySelector('.tooltip');
        if (!lastChanceCollectionTooltip) return;
        const triangle = lastChanceCollectionTooltip.querySelector('.tooltip_triangle');
        const questionMark = lastChanceCollection.querySelector('.question_mark');
        const setupPos = () => {
            lastChanceCollectionTooltip.style.display = 'block';
            if(window.innerWidth < 750) {
                const left = lastChanceCollectionTooltip.getBoundingClientRect().left;
                const sMarginLeft = getComputedStyle(lastChanceCollectionTooltip.closest('.product__wrapper')).marginLeft;
                const marginLeft = parseInt(sMarginLeft.substring(0,sMarginLeft.length - 2));
                if(left < marginLeft) {
                    const questionWidth = questionMark.offsetWidth;
                    const questionLeft = questionMark.offsetLeft;
                    lastChanceCollectionTooltip.style.left = '0px';
                    triangle.style.left = `${questionLeft}px`;
                    triangle.style.right = 'unset';
                }
            } else {
                triangle.style.left = 'unset';
                triangle.style.right = '16px';
                lastChanceCollectionTooltip.style.right = `-16px`;
                lastChanceCollectionTooltip.style.left = 'unset';
            }
            lastChanceCollectionTooltip.style.top = `-${lastChanceCollectionTooltip.offsetHeight + triangle.offsetHeight}px`;
            lastChanceCollectionTooltip.style.display = '';
        }
        window.addEventListener('resize',()=>{
            setupPos();
        });
        setupPos();
    }
});